module.exports = __webpack_public_path__ + "static/media/color-black.871a4e57.svg";